"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useImTheme = useImTheme;
var _react = require("react");
var _imThemeContext = require("./imThemeContext");
function useImTheme() {
  var contextValue = (0, _react.useContext)(_imThemeContext.imThemeContext);
  if (!contextValue) {
    throw new Error('imThemeContext value is undefined. Make sure you use the ImThemeProvider before using the context.');
  }
  return contextValue;
}